import React from 'react';
import Helmet from 'react-helmet';
import { FaEnvelope } from 'react-icons/lib/fa';
import Header from '../components/Header/Header';
import Container from '../components/Container/Container';
import Footer from '../components/Footer/Footer';
import config from '../../config/SiteConfig';
import styles from './services.module.scss';

const Services = () => (
  <div className="container about-container">
    <Helmet title={`Services | ${config.siteTitle}`} />
    <Header>Services</Header>
    <Container text>
      <ul className={styles.list}>
        <li>UX/UI Copy</li>
        <li>Email Copy</li>
        <li>Content Audits</li>
        <li>Voice and Tone Guides</li>
        <li>Web Content and Blogs</li>
        <li>Editing and Proofreading</li>
        <li className={styles.button}>
          <a href="mailto:hello@rach.nz" target="_blank" rel="noopener noreferrer">
            <FaEnvelope /> Let's chat
          </a>
        </li>
      </ul>
    </Container>
    <Footer />
  </div>
);

export default Services;



// WEBPACK FOOTER //
// ./src/pages/services.jsx